var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWorkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_11720",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77.6086,
    height: 77.6086,
    fill: "#1B436A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_11720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9728 29.1033H61.4402V22.6359H54.9728V29.1033ZM54.9728 42.0381H61.4402V35.5707H54.9728V42.0381ZM54.9728 54.9729H61.4402V48.5055H54.9728V54.9729ZM3.2337 67.9077V35.5707L25.8696 19.4023L48.5054 35.5707V67.9077H32.3369V48.5055H19.4022V67.9077H3.2337ZM54.9728 67.9077V32.337L32.3369 16.0069V9.70117H74.375V67.9077H54.9728Z",
    fill: "#1B436A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWorkLight);
export default __webpack_public_path__ + "static/media/home_work_light.d0534d8e0eae7f7e073302a56a8fe02f.svg";
export { ForwardRef as ReactComponent };